import { useState } from "react";
import { Plus } from "react-feather";
import { useDropzone } from "react-dropzone"; // Import react-dropzone
import axios from "axios";
import { baseurl } from "../Baseurl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const AddAssignee = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [department, setDepartment] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [permission, setPermission] = useState("");

  // Handle dropped file
  const handleDrop = (acceptedFiles) => {
    setProfileImage(acceptedFiles[0]);
  };

  // Use the Dropzone hook
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    accept: "image/*", // Only accept image files
  });


  const adminID = localStorage.getItem("adminID");
  console.log(adminID);
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", fullName);
    formData.append("email", email);
    formData.append("role", role);
    formData.append("department", department);
    formData.append("permission", permission);
    formData.append("adminId", adminID);
    
    if (profileImage) {
      formData.append("profileImage", profileImage);
    }

    // Log the form data in a readable way
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    try {
      // Make an API call to add assignee (replace URL with your endpoint)
      const response = await axios.post(`${baseurl}createAssignee`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response.data);
      
      // Show success toast notification
      toast.success("Assignee created successfully!");

      // Reload the page
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Reload after 2 seconds (adjust as needed)
    } catch (error) {
  console.error("Error adding assignee", error);

  // Extract error message from response (fallback to generic if not available)
  const errorMessage = error.response?.data?.message || "Error adding assignee. Please try again.";

  // Show dynamic error toast
  toast.error(errorMessage);
}

  };
  

  return (
    <>
      <button
        className="new-project-btn txtoneline"
        data-bs-toggle="modal"
        data-bs-target="#addAssigneeModal"
      >
        <Plus />
        &nbsp;Add User
      </button>

      <div
        className="modal fade"
        id="addAssigneeModal"
        tabIndex="-1"
        aria-labelledby="addAssigneeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addAssigneeModalLabel">
                Add New User
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body text-start">
              <form onSubmit={handleSubmit}>
                {/* Full Name */}
                <div className="mb-3">
                  <label htmlFor="fullName" className="form-label">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="fullName"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    placeholder="👤 Enter full name"
                  />
                </div>

                {/* Email */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="📧 Enter email"
                  />
                </div>

                {/* Role Dropdown */}
                <div className="mb-3">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <select
                    className="form-select"
                    id="role"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <option value="">Select Role</option>
                    <option value="admin">Admin</option>
                    <option value="manager">Manager</option>
                    <option value="developer">Developer</option>
                    {/* Add other roles as needed */}
                  </select>
                </div>

                {/* Department Dropdown */}
                <div className="mb-3">
                  <label htmlFor="department" className="form-label">
                    Department
                  </label>
                  <select
                    className="form-select"
                    id="department"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                  >
                    <option value="">Select Department</option>
                    <option value="engineering">Engineering</option>
                    <option value="sales">Sales</option>
                    <option value="hr">HR</option>
                    {/* Add other departments as needed */}
                  </select>
                </div>



                {/* Department Dropdown */}
                <div className="mb-3">
                  <label htmlFor="permission" className="form-label">
                    Set Permission
                  </label>
                  <select
                    className="form-select"
                    id="permission"
                    value={permission}
                    onChange={(e) => setPermission(e.target.value)}
                  >
                    <option value="">Select Permission</option>
                    <option value="project">projects</option>
                    <option value="operation">Operations</option>
                    <option value="strategic">Strategic</option>
                    {/* Add other departments as needed */}
                  </select>
                </div>


                {/* Drag-and-Drop for Profile Image */}
                <div className="mb-3">
                  <label htmlFor="profileImage" className="form-label">
                    Profile Image
                  </label>
                  <div
                    {...getRootProps({
                      className: "profile-image-upload-box",
                      style: {
                        border: "2px dashed #ddd",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                      },
                    })}
                  >
                    {profileImage ? (
                      <div>
                        <img
                          src={URL.createObjectURL(profileImage)}
                          alt="profile preview"
                          style={{
                            maxWidth: "150px",
                            maxHeight: "150px",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                        <p>{profileImage.name}</p>
                      </div>
                    ) : (
                      <p>Drag & Drop or Click to Select Profile Image</p>
                    )}
                    <input {...getInputProps()} hidden />
                  </div>
                </div>

                {/* Submit Button */}
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-success">
                    Add Assignee
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"  // Colored theme for toasts
      />
        
      </div>
    </>
  );
};

export default AddAssignee;
